_ = require("lodash")

ClubShowCtrl = ($rootScope, $scope, $location, $routeParams, RoundInfoService, $analytics, clubInfo, fromJapan, ClubService, $filter, $translate) ->

  $scope.showBasicInfo = ->
    $scope.isShowBasicInfo = !$scope.isShowBasicInfo

  $scope.showRecentUsers = ->
    $scope.isShowRecentUsers = !$scope.isShowRecentUsers

  $scope.showRankingUsers = ->
    $scope.isShowRankingUsers = !$scope.isShowRankingUsers

  $scope.seeMoreRanking = ->
    $scope.isShowSeeMore = !$scope.isShowSeeMore

  $scope.showMap = ->
    $scope.isShowMap = !$scope.isShowMap

  $scope.getTextOfAvatarRecent = (item) ->
    $avatarElement = $(".avatar-for-#{item.id} .avatar-image-text:not(.is-small)")

    if item.display_text_avatar.length == 1
      $avatarElement.removeClass('two-characters')
      $avatarElement.addClass('one-character')
    else
      $avatarElement.removeClass('one-character')
      $avatarElement.addClass('two-characters')
    item.display_text_avatar

  $scope.isAvatarColorRecent = (item) ->
    item.avatar_image_path?.indexOf('avatar_color') > -1

  $scope.displayUserName = (user) ->
    return user.nickname if user.nickname
    firstName = user.first_name ? ''
    lastName = user.last_name ? ''
    if firstName + lastName == ''
      return $filter('translate')('_RANKING_GROUP.EVENT_RANK.UNNAMED')

    if /^ja/i.test $translate.preferredLanguage()
      return lastName + " " + firstName
    return firstName + " " + lastName

  $scope.goToProfilePage = (userId) ->
    window.location.href = '/profile/' + userId

  _setRakutenLink = (rakutenId) ->
    return unless rakutenId
    RoundInfoService.getRakutenLink(rakutenId).then (response) ->
      $scope.rakutenLink = response.data.Item.reserveCalUrl

  $analytics.eventTrack('GNUserScore_loaded')
  $scope.clubInfo = clubInfo
  $scope.clubInfo.showRakutenId = clubInfo.rakuten_id and fromJapan
  $scope.lineLink = encodeURIComponent("#{clubInfo.name} - GN+ SCORE\n#{$location.absUrl()}")

  $rootScope.title = clubInfo.name
  $scope.clubHeader = true
  $scope.isShowBasicInfo = false
  $scope.isShowRecentUsers = true
  $scope.isShowRankingUsers = true
  $scope.isShowSeeMore = false
  $scope.isShowMap = false
  $scope.recommentPlans = []

  if clubInfo.rakuten_id
    ClubService.getRecommendPlans(clubInfo.rakuten_id).then (data) ->
      _.forEach data.Items, (Item) ->
        $scope.recommentPlans = _.union($scope.recommentPlans, Item.Item.planInfo)
        $scope.ratingUrlPC = Item.Item.ratingUrlPC
        _setRakutenLink clubInfo.rakuten_id

  $scope.$on "courseChanged.gnp.club", (event, course_id) ->
    $scope.recentPlayedUsers = []
    $scope.rankingUsers = []
    $scope.isShowSeeMore = false

    ClubService.getRecentUsers(clubInfo.id, { page_size: 6, course_id: course_id }).then (data) ->
      $scope.recentPlayedUsers = data.data

    ClubService.getRankingUsers(clubInfo.id, { page_size: 20, course_id: course_id }).then (data) ->
      $scope.rankingUsers = data.data


ClubShowCtrl.$inject = [
  '$rootScope'
  '$scope'
  '$location'
  '$routeParams'
  'RoundInfoService'
  '$analytics'
  'clubInfo'
  'fromJapan'
  'ClubService'
  '$filter'
  '$translate'
]

module.exports = ClubShowCtrl



// WEBPACK FOOTER //
// ./~/coffeelint-loader!./ngapp/javascript/web/club/club-controller.coffee